import React, {Dispatch, FC, SetStateAction, useState} from "react";
import Header from "../Header";
import {Alert, AlertTitle, Grid} from "@mui/material";
import Banner from "./Banner";
import WelcomeSection from "./WelcomeSection";

export interface ScreenProps {
  message: boolean;
  setMessage: Dispatch<SetStateAction<boolean>>;
}

const Screens: FC = () => {
  const [message, setMessage] = useState<boolean>(false);

  return (
    <Grid>
      <Header/>
      <Banner/>
      <WelcomeSection message={message} setMessage={setMessage}/>
      <Grid
        container
        justifyContent={"center"}
        sx={{
          borderTopRightRadius: "200px",
          backgroundColor: "#ffffff",
          paddingTop: 10,
          paddingX: 2,
        }}
        spacing={2}
      >
        <Grid item xs={12} lg={8} sx={{pb: 5}}>
          <Alert severity="error">
            <AlertTitle>Registrations for 16th ICA-AP Regional Assembly are now closed.</AlertTitle>
            If you want to attend, kindly contact the ICA-AP secretariat at <a
            href={"mailto:secretariat@regionalassembly.coop"}>
            secretariat@regionalassembly.coop
          </a>.
          </Alert>
        </Grid>
      </Grid>
      {/*<RegistrationForm message={message} setMessage={setMessage} />*/}
    </Grid>
  );
};

export default Screens;
